import Dashboard from '@/components/Dashboard'
import MaintenanceStaff from '@/components/Maintenance/MaintenanceStaff/MaintenanceStaff'

// Note: `MaintenanceStaff` has no page-level container of its own - it previously relied on
// being nested under the (now-removed) shared `MaintenancePage`/toolbar shell for layout. Kept
// wrapped in the same `Dashboard.Container`/`ctp-maintenance` scoping (rather than the new `Page`
// component) so the maintenance-staff-list.scss double-scroll fix still applies unchanged.
export const MaintenanceStaffPage = () => (
  <Dashboard.Container className="ctp-maintenance">
    <MaintenanceStaff />
  </Dashboard.Container>
)
